export default {
  noticias: [],

}